export const ApplicationTagEventStatusArray = ['APPROVED', 'DECLINED', 'UNDER_REVIEW', 'ADOPTED', 'PAID', 'SIGNED'] as const
export type ApplicationTagEventStatus = typeof ApplicationTagEventStatusArray[number]

export default interface IApplicationTag {
  id: number,
  uuid: string,
  name: string,
  description: string
}
